const state = {
  offices: []
}

export const customEditorRequiredFields = [
  { key: 'client_admin.offices' },
]

export default state
